// extracted by mini-css-extract-plugin
export default {"messageInputForm":"messageInputForm---oDb68","messageTextArea":"messageTextArea---_TkcL","sendButton":"sendButton---orrmq"};